export default __webpack_public_path__ + "static/media/deal3.0b72a573.png";